module.exports = __webpack_public_path__ + "static/img/lifestyle_29.2c52ca4d.jpeg";